import { NotFoundError } from '@cian/peperrors/shared';

import { TErrorInfo, EStatusCode } from './types/errorInfo';
import { TSearchPromosResponse } from '../../../repositories/newbuilding-promos/v2/search-promos';

export function assertNotFoundError(response: TSearchPromosResponse) {
  if (response.statusCode !== 400) {
    return;
  }

  const { errors, message } = response.response;

  const notFoundInfo = errors?.find((error: TErrorInfo) => {
    return error.key === 'statusCode' && error.code === EStatusCode.NotFound;
  });

  if (!notFoundInfo) {
    return;
  }

  throw new NotFoundError({
    domain: 'shared/services/promosSearch/assert/assertNotFoundError#assertNotFoundError()',
    message: message as string,
  });
}
